var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllOverviewChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 96,
    viewBox: "0 0 301 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7D084",
    fillRule: "nonzero",
    d: "M20.62 39a100 100 0 0 0 28.54-25.24C54.33 7.17 60.12 3.33 67 7.38A24.51 24.51 0 0 0 90.25 8.6l1.9-.89a71.07 71.07 0 0 1 61.63.18L166.63 14a24.24 24.24 0 0 0 16.43 1.71 24.3 24.3 0 0 1 13.91.79 32.44 32.44 0 0 0 27.3-2.78c11.38-6.57 19.64-10.1 33.64-1 12.9 8.37 25.52 15.46 28.18 33.29 2.46 16.48-7.78 29.23 3.26 39.42l6.28 5.79h-284C-1.35 59.74 9.41 45.44 20.62 39z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M298.48 91.2H.52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F5F5F",
    fillRule: "nonzero",
    d: "M284.63 93.2H231l26.82-41.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M257.82 51.76l26.81 41.44H231l26.82-41.44m0-2a2 2 0 0 0-1.68.91l-26.82 41.44a2 2 0 0 0-.07 2 2 2 0 0 0 1.75 1h53.63a2 2 0 0 0 1.68-3.09L259.5 50.67a2 2 0 0 0-1.68-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "nonzero",
    d: "M231 93.2h34.08l-17.04-26.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    fillRule: "nonzero",
    d: "M251.8 93.2h-40.34l20.17-31.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M231.63 62l20.17 31.2h-40.35L231.63 62m0-2a2 2 0 0 0-1.68.91l-20.17 31.2a2 2 0 0 0 1.67 3.09h40.35a2 2 0 0 0 1.68-3.09l-20.17-31.18a2 2 0 0 0-1.68-.91V60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F5F5F",
    fillRule: "nonzero",
    d: "M211.46 93.2h29.85l-14.93-23.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    fillRule: "nonzero",
    d: "M231 93.2h-53.63l26.82-41.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M204.19 51.76L231 93.2h-53.63l26.82-41.44m0-2a2 2 0 0 0-1.68.91l-26.82 41.44a2 2 0 0 0-.07 2 2 2 0 0 0 1.75 1H231a2 2 0 0 0 1.68-3.09l-26.81-41.35a2 2 0 0 0-1.68-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    fillRule: "nonzero",
    d: "M177.37 93.2h30.69l-15.34-23.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillRule: "nonzero",
    d: "M198.13 93.2h-95.97l47.98-74.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    fillRule: "nonzero",
    d: "M157.82 85.27h4.68a5.32 5.32 0 1 0 0-10.64h-22.75a5.87 5.87 0 0 1 0-11.73H147a13.65 13.65 0 0 0 13.66-13.66l-.42-1.85h-12.71l-7.71 8.73-6.82-7.89-2-1.31-30.12 46.28h49a7.93 7.93 0 0 1 7.94-7.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADBBD0",
    fillRule: "nonzero",
    d: "M169.38 47.39h-21.86l-7.7 8.73-8.84-9.2 19.16-27.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92A1B7",
    fillRule: "nonzero",
    d: "M139.59 55.85l10.55-36.81-19.16 27.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M150.14 19l48 74.16h-96l48-74.16m0-2a2 2 0 0 0-1.68.91l-48 74.16a2 2 0 0 0 1.68 3.09h96a2 2 0 0 0 1.68-3.09l-48-74.07a2 2 0 0 0-1.68-.91V17z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M169.38 47.39h-21.85l-7.71 8.73-7.63-8.73M149.89 93.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeDasharray: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M150.87 89.37a7.94 7.94 0 0 1 6.95-4.1h4.68a5.32 5.32 0 0 0 5.32-5.27 5.32 5.32 0 0 0-5.32-5.32h-22.75a5.87 5.87 0 0 1 0-11.73H147a13.66 13.66 0 0 0 13.52-11.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M160.68 49.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M194.93 6c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13 5.82-13 13-13m0-2c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.93,
    cy: 19.04,
    r: 13,
    fill: "#F5BC41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C354",
    fillRule: "nonzero",
    d: "M181.93 19c0 1.205.171 2.404.51 3.56a11.14 11.14 0 1 0 13.91-16.44 13.37 13.37 0 0 0-1.42-.12c-7.18 0-13 5.82-13 13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D84F10",
    fillRule: "nonzero",
    d: "M56.45 81.76l-1.88 3.62v.08a5.38 5.38 0 0 1-1.22 1.85l-5.1 5.11a2.754 2.754 0 0 1-3.89-3.9l4.3-4.3a5.24 5.24 0 0 0 1.22-1.85l1.23-2.23L53 76.71l3.45 5.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2470D",
    fillRule: "nonzero",
    d: "M56.45 81.76l-1.88 3.62-3.5-5.24 1.89-3.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M53 76.72l3.49 5-1.92 3.71a5.43 5.43 0 0 1-1.22 1.84l-5.1 5.11a2.76 2.76 0 0 1-3.89 0 2.76 2.76 0 0 1 0-3.89l4.3-4.31a5.38 5.38 0 0 0 1.22-1.85L53 76.72m0-2h-.1a2 2 0 0 0-1.65 1l-3.12 5.66a1.63 1.63 0 0 0-.11.23 3.35 3.35 0 0 1-.76 1.15l-4.31 4.32a4.74 4.74 0 0 0 0 6.72 4.74 4.74 0 0 0 6.71 0l5.11-5.1a7.73 7.73 0 0 0 1.62-2.42l1.88-3.63a2 2 0 0 0-.14-2.05l-3.49-5a2 2 0 0 0-1.64-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6127",
    fillRule: "nonzero",
    d: "M69.51 70.28l-2-1-.83-2.53a9.38 9.38 0 0 0-8.79-6.52c-3.09 0-4.8.86-8 2.16a8.25 8.25 0 0 0-4.28 4L45 67.52a2.76 2.76 0 0 0 1.22 3.69A2.71 2.71 0 0 0 49.9 70l.58-1.17a2.75 2.75 0 0 1 1.41-1.32l2.31-.93-1.14 4.55-.17.67a5.53 5.53 0 0 0 1.28 5l5.15 5.62a5.47 5.47 0 0 1 1.28 2.38l1.57 6.3a2.752 2.752 0 1 0 5.34-1.33l-1.91-7.62a5.42 5.42 0 0 0-1.28-2.38l-3.91-4.27 1.47-5.86.48 1.36a5.5 5.5 0 0 0 2.73 3.18l2 1A2.71 2.71 0 0 0 70.74 74a2.79 2.79 0 0 0-1.23-3.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillRule: "nonzero",
    d: "M70.74 74a2.71 2.71 0 0 1-3.65 1.22l-2-1A5.5 5.5 0 0 1 62.36 71l-.47-1.42-1.47 5.86L56.3 73l-3.24-1.91 1.14-4.55-2.31.93a2.75 2.75 0 0 0-1.41 1.32L49.9 70a2.71 2.71 0 0 1-3.65 1.23A2.76 2.76 0 0 1 45 67.52l.57-1.17a8.25 8.25 0 0 1 4.28-4c3.21-1.3 4.92-2.17 8-2.16a8.91 8.91 0 0 1 4.7 1.35 9.58 9.58 0 0 1 4.09 5.17l.83 2.53 2 1A2.79 2.79 0 0 1 70.74 74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    fillRule: "nonzero",
    d: "M70.74 74a2.71 2.71 0 0 1-3.65 1.22l-2-1A5.5 5.5 0 0 1 62.36 71l-.47-1.42-1.47 5.86L56.3 73c4-1.41 5.75-8.63 6.29-11.45a9.58 9.58 0 0 1 4.09 5.17l.83 2.53 2 1A2.79 2.79 0 0 1 70.74 74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M57.85 60.22a9.36 9.36 0 0 1 8.78 6.52l.84 2.53 2 1A2.79 2.79 0 0 1 70.74 74a2.73 2.73 0 0 1-2.44 1.5 2.64 2.64 0 0 1-1.21-.3l-2.91-2.12c-1.29-.65-2.09-4.55-2.09-4.55l-1.68 7 3.91 4.27a5.42 5.42 0 0 1 1.28 2.38l1.91 7.65a2.75 2.75 0 0 1-2.67 3.41 2.75 2.75 0 0 1-2.67-2.08l-1.57-6.3a5.53 5.53 0 0 0-1.28-2.38l-5.15-5.62a5.5 5.5 0 0 1-1.28-5l1.31-5.22-2.31.93a2.71 2.71 0 0 0-1.41 1.32L49.9 70a2.73 2.73 0 0 1-2.44 1.52 2.63 2.63 0 0 1-1.21-.29A2.76 2.76 0 0 1 45 67.52l.57-1.17a8.27 8.27 0 0 1 4.27-4c3.2-1.29 4.91-2.16 8-2.16m0-2c-3.1 0-5 .78-7.64 1.87l-1.09.44a10.2 10.2 0 0 0-5.31 4.94l-.58 1.17a4.74 4.74 0 0 0 4.23 6.86 4.71 4.71 0 0 0 3.33-1.38 7.52 7.52 0 0 0 1.9 6.06l5.15 5.62c.393.432.675.954.82 1.52l1.57 6.29a4.74 4.74 0 0 0 4.61 3.6 4.47 4.47 0 0 0 1.17-.11 4.74 4.74 0 0 0 2.92-2.16 4.69 4.69 0 0 0 .54-3.6l-1.91-7.64a7.5 7.5 0 0 0-1.75-3.26l-3.2-3.48.11-.44c.12.1.25.19.38.28l2.82 2 .27.17a4.76 4.76 0 0 0 2.12.51 4.71 4.71 0 0 0 4.23-2.63 4.8 4.8 0 0 0-2.12-6.38l-1.26-.63-.58-1.75a11.32 11.32 0 0 0-10.67-7.84l-.06-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M61.39 75a35.52 35.52 0 0 0-8.79-3.73"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.39,
    cy: 53.34,
    r: 4.13,
    fill: "#F6C354",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M61.39 49.22a4.13 4.13 0 0 1 .41 8.23h-.42a4.13 4.13 0 0 1-.38-8.21c.14-.01.28-.01.42 0m0-2h-.62a6.13 6.13 0 0 0 .61 12.22h.62a6.13 6.13 0 0 0-.61-12.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M64.76 51c.205.313.372.649.5 1l-7.94.8a4.6 4.6 0 0 1 .3-1l7.14-.8m.48-1.05l-.58.06-7.14.72-.58.06-.24.54a5.46 5.46 0 0 0-.37 1.27l-.2 1.28 1.29-.13 7.94-.8 1.29-.13-.45-1.22a5.7 5.7 0 0 0-.62-1.17l-.34-.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M65.26 52a4.86 4.86 0 0 0-.5-1l-7.14.72a4.6 4.6 0 0 0-.3 1l7.94-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M69.92 71.22l12.82-23.83M66.28 77.98l.87-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M81 48.91l14.31 7.4-7.34 2.15 2.49 7.23-14.31-7.4L81 48.91m0-2a1.812 1.812 0 0 0-.61.1 2 2 0 0 0-1.17 1l-4.85 9.38a2 2 0 0 0 .86 2.7l14.31 7.4a2 2 0 0 0 .92.22 2 2 0 0 0 1.89-2.65l-1.8-5.25 5.32-1.56a2 2 0 0 0 .36-3.69l-14.36-7.43a2.071 2.071 0 0 0-.91-.22H81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D84F10",
    fillRule: "nonzero",
    d: "M90.42 65.69l-14.31-7.4 4.85-9.38 14.31 7.4-7.34 2.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2470D",
    fillRule: "nonzero",
    d: "M76.107 58.298l4.85-9.38 1.82.94-4.85 9.381z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllOverviewChallenge);
export default __webpack_public_path__ + "static/media/ill_overview_challenge.58b6445952cfcee51165680603053b07.svg";
export { ForwardRef as ReactComponent };